/**
 * @generated SignedSource<<db76c3ad3c15b809db59bed4131337b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type KeyResultReorderMutation$variables = {
  newIndex: number;
  objective: string;
  oldIndex: number;
};
export type KeyResultReorderMutation$data = {
  readonly KeyResult_Reorder: {
    readonly objective: {
      readonly id: string;
      readonly keyResults: ReadonlyArray<{
        readonly id: string;
        readonly order: number;
      }>;
    } | null;
  } | null;
};
export type KeyResultReorderMutation = {
  response: KeyResultReorderMutation$data;
  variables: KeyResultReorderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newIndex"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objective"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "oldIndex"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "newIndex",
        "variableName": "newIndex"
      },
      {
        "kind": "Variable",
        "name": "objectiveId",
        "variableName": "objective"
      },
      {
        "kind": "Variable",
        "name": "oldIndex",
        "variableName": "oldIndex"
      }
    ],
    "concreteType": "ReorderKeyResultMutation",
    "kind": "LinkedField",
    "name": "KeyResult_Reorder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Objective",
        "kind": "LinkedField",
        "name": "objective",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyResult",
            "kind": "LinkedField",
            "name": "keyResults",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "KeyResultReorderMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "KeyResultReorderMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "b206bafcae634fd79f5e2af1701d57ac",
    "id": null,
    "metadata": {},
    "name": "KeyResultReorderMutation",
    "operationKind": "mutation",
    "text": "mutation KeyResultReorderMutation(\n  $objective: ID!\n  $oldIndex: Int!\n  $newIndex: Int!\n) {\n  KeyResult_Reorder(objectiveId: $objective, oldIndex: $oldIndex, newIndex: $newIndex) {\n    objective {\n      id\n      keyResults {\n        id\n        order\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a4d6160df80ba17545202fe8d19a137";

export default node;
